import { ArtifactSourceData, GenericArtifactSourceHolder } from '@/components/canvas/CanvasElementSourceProviders/GenericArtifactFactory'
import { SourceProviderFactory } from '@/components/canvas/CanvasElementSourceProviders/SourceProviderFactory'
import { Camera } from '@/types/Cameras'

export class HeatmapSourceHolder extends GenericArtifactSourceHolder<ArtifactSourceData> {
  readonly artifactType = 'heatmap'
}

export class HeatmapSourceProviderFactory extends SourceProviderFactory<HeatmapSourceHolder> {
  readonly providerType = 'artifact.heatmap'

  createSourceHolder(cameraId: string, timestamp: number, camera: Camera): HeatmapSourceHolder {
    return new HeatmapSourceHolder(cameraId, timestamp, camera)
  }
}
